import React from 'react';

import { Button } from 'components/Button';

import { StyledTextField } from 'components/Input/styles';

import CustomModal from 'components/CustomModal';

import { InfoText, HelpText } from './styles';

const CONFIRMATION_TEXT = 'DELETE';

const RemoveEntityModal: React.FC<{
  onClose: () => void;
  handleRemoveEntity: () => void;
  entityType: string;
}> = ({ onClose, handleRemoveEntity, entityType }): React.ReactElement => {
  const [openModal, setOpenModal] = React.useState(true);
  const [confirmationText, setConfirmationText] = React.useState('');

  const onCloseModal = (): void => {
    setOpenModal(false);
    onClose();
  };

  const onDelete = (): void => {
    handleRemoveEntity();
    onCloseModal();
  };

  return (
    <CustomModal
      openModal={openModal}
      onClose={onCloseModal}
      modalTitle={`Delete ${entityType}`}
      cancelButton={
        <Button id="cancel-action-button" onClick={onCloseModal} variant="outlined" size="large">
          Cancel
        </Button>
      }
      submitButton={
        <Button
          id="delete-action-button"
          onClick={onDelete}
          disabled={confirmationText !== CONFIRMATION_TEXT}
          variant="contained"
          size="large"
          color="error"
        >
          Delete
        </Button>
      }
    >
      <InfoText>Are you sure you want to delete this record?</InfoText>
      <InfoText>Once removed, you will not be able to recover this data.</InfoText>
      <HelpText>
        Please type in <b>DELETE</b> to confirm
      </HelpText>
      <StyledTextField
        variant="outlined"
        placeholder="Please type in DELETE to confirm"
        value={confirmationText}
        onChange={(e) => {
          setConfirmationText(e.target.value);
        }}
      />
    </CustomModal>
  );
};

export default RemoveEntityModal;
